/**
 * JavaScript Document
 * Version: 1.0.0
 * Date: 4/20/2020
 * Author: Liu Changkun
 * Copyright: www.east.net
 */
import http, { formConfig } from "@/utils/http";
const url = action => `/sync/task/${action[0]}`;

export default class TASK {
  static CREATE(data) {
    return http.post(url`create`, data, formConfig);
  }
  static HISTORY(params) {
    return http.get(url`history`, { params });
  }
  static DETAIL(params) {
    return http.get(url`detail`, { params });
  }
  static TRACK(params) {
    return http.get(url`track`, { params });
  }
}
